

<div class=" row animated fadeIn slow heroe">
            <div class="frase">
                <div class="frase-centrar">
                    <p class="cite ">"La Presencia en internet no es un lujo, es una NECESIDAD.</p>
                    <h1>Soy Marco Antonio Islas Durán...<span> Y SOY DESARROLLADOR WEB FREELANCE.</span></h1>
                    <div class="botones">
                        <div class="marker"><span class="fas fa-map-marker-alt"> CDMX</span> </div>
                        <button (click)='verContacto()' class="animated pulse btn btn-contacto">Contacto</button>
                        <button (click)='verPortafolio()' class="animated flash btn btn-portafolio">Portafolio</button>
                    </div>
                </div>
            </div>
        </div>
